import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { FlatpickrModule } from "angularx-flatpickr";

import { AiDocViewerComponent } from "./ai-doc-viewer/ai-doc-viewer.component";
import { AiExtractionPanelComponent } from "./ai-extraction-panel/ai-extraction-panel.component";
import { AiExtractionReviewComponent } from "./ai-extraction-review/ai-extraction-review.component";
import { AiProvenanceDirective } from "./ai-provenance.directive";

/**
 * Extração de documentos com IA no formulário do imóvel. Módulo próprio para
 * não misturar declarações com as do PropertiesModule.
 */
@NgModule({
  declarations: [
    AiExtractionPanelComponent,
    AiExtractionReviewComponent,
    AiDocViewerComponent,
    AiProvenanceDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    TranslateModule,
    FlatpickrModule,
  ],
  exports: [AiExtractionPanelComponent, AiProvenanceDirective],
})
export class AiExtractionModule {}
